var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_41025_42688",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3412C0 7.78275 0 5.00354 1.41552 3.05524C1.87268 2.42602 2.42602 1.87268 3.05524 1.41552C5.00354 0 7.78275 0 13.3412 0H28.6588C34.2172 0 36.9965 0 38.9448 1.41552C39.574 1.87268 40.1273 2.42602 40.5845 3.05524C42 5.00354 42 7.78275 42 13.3412V28.6588C42 34.2172 42 36.9965 40.5845 38.9448C40.1273 39.574 39.574 40.1273 38.9448 40.5845C36.9965 42 34.2172 42 28.6588 42H13.3412C7.78275 42 5.00354 42 3.05524 40.5845C2.42602 40.1273 1.87268 39.574 1.41552 38.9448C0 36.9965 0 34.2172 0 28.6588V13.3412Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3412C0 7.78275 0 5.00354 1.41552 3.05524C1.87268 2.42602 2.42602 1.87268 3.05524 1.41552C5.00354 0 7.78275 0 13.3412 0H28.6588C34.2172 0 36.9965 0 38.9448 1.41552C39.574 1.87268 40.1273 2.42602 40.5845 3.05524C42 5.00354 42 7.78275 42 13.3412V28.6588C42 34.2172 42 36.9965 40.5845 38.9448C40.1273 39.574 39.574 40.1273 38.9448 40.5845C36.9965 42 34.2172 42 28.6588 42H13.3412C7.78275 42 5.00354 42 3.05524 40.5845C2.42602 40.1273 1.87268 39.574 1.41552 38.9448C0 36.9965 0 34.2172 0 28.6588V13.3412Z",
    fill: "#0BABFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H42H0ZM42 34.5882C42 39.6481 37.8981 43.75 32.8382 43.75H9.16177C4.10186 43.75 0 39.6481 0 34.5882C0 37.7151 3.31836 40.25 7.41177 40.25H34.5882C38.6816 40.25 42 37.7151 42 34.5882ZM0 42V0V42ZM42 0V42V0Z",
    fill: "black",
    fillOpacity: 0.12,
    mask: "url(#path-1-inside-1_41025_42688)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9998 31.2082C26.6377 31.2082 31.2082 26.6377 31.2082 20.9998C31.2082 15.3619 26.6377 10.7915 20.9998 10.7915C15.3619 10.7915 10.7915 15.3619 10.7915 20.9998C10.7915 26.6377 15.3619 31.2082 20.9998 31.2082ZM19.979 26.104V22.0207H15.8957V19.979H19.979V15.8957H22.0207V19.979H26.104V22.0207H22.0207V26.104H19.979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidPlus);
export default __webpack_public_path__ + "static/media/solid-plus.94818f394c1a822875f6a7ab87d754c1.svg";
export { ForwardRef as ReactComponent };